<script setup>
import { ChevronDownIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const {
  row,
} = defineProps({
  row: {
    type: Object,
    required: true,
  }
});
</script>

<template>
  <div class="flex items-center justify-start gap-2 p-4">

    <ActionButton
      v-if="row.getCanExpand()"
      size="small"
      type="secondary"
      class="size-8"
      :title="row.getIsExpanded() ? t('button.collapse') : t('button.expand')"
      :callback="() => row.toggleExpanded()"
    >
      <ChevronDownIcon
        class="size-5 flex-shrink-0 duration-150"
        :class="{
          'rotate-180 transform': row.getIsExpanded(),
        }"
      />
    </ActionButton>
  </div>
</template>
